<script lang="ts">
import type { ButtonProps } from './AwButton.vue'

export interface BulkActionProps {
  count: number
  actions: ButtonProps[]
}

export interface BulkActionEmits {
  (e: 'unselect'): void
}

const ui = {
  root: 'flex items-center justify-center border border-secondary-400 pl-3 pr-2 py-2 rounded-xl shadow-xs bg-black',
  wrapper: 'flex flex-wrap items-center gap-2',
  countWrapper: 'flex items-center h-6.75',
  count: 'text-md font-medium min-w-max text-white',
  hr: 'sm:block hidden w-px h-4.5 bg-secondary-300',
}
</script>

<script setup lang="ts">
import AwButton from './AwButton.vue'

defineProps<BulkActionProps>()
const emits = defineEmits<BulkActionEmits>()
</script>

<template>
  <div :class="ui.root">
    <div :class="ui.wrapper">
      <p :class="ui.countWrapper">
        <span :class="ui.count">
          {{ count }} sélectionné(s)
        </span>
      </p>
      <div :class="ui.hr" />
      <AwButton variant="ghost" size="md" color="secondary" class="text-white! hover:bg-gray-900!" label="Désélectionner" @click="emits('unselect')" />
      <AwButton
        v-for="action, index in actions"
        :key="index"
        v-bind="{
          ...action,
          variant: action.variant ?? 'solid',
          size: 'md',
          color: action.color ?? 'primary',
        }"
      />
    </div>
  </div>
</template>
